import { useQuery } from '@tanstack/react-query';

import { qrcodeAPIService } from '~/api/qrcode';
import { qrCodeKeys } from '~/constants/queryKeys';

export default function useQrCodeData<T>({ qrCodeId }: { qrCodeId?: string }) {
  return useQuery({
    queryFn: () => qrcodeAPIService.getQrCodeById(qrCodeId),
    queryKey: qrCodeKeys.qrCodeById(qrCodeId),
    enabled: !!qrCodeId,
    select: (response) => response.data as T | undefined,
  });
}
